import { render } from "./RightSwiper.vue?vue&type=template&id=fff73d6c"
import script from "./RightSwiper.vue?vue&type=script&lang=js"
export * from "./RightSwiper.vue?vue&type=script&lang=js"
script.render = render

export default script